<!-- Application -->
<template>
    <header class="demo-header">
        <div id="title-container">
            <a
                id="title"
                :href="link"
            >
                <h1>{{ title }}</h1>
            </a>
        </div>
        <slot/>
        <div id="tools">
            <bryntum-button
                text="Download Trial"
                href="https://bryntum.com/download/?product=schedulerpro"
                cls="b-green b-raised"
            />
            <bryntum-button
                ref="codeButton"
                icon="b-icon-code"
                tooltip="Click to show the code viewer"
                cls="b-raised b-blue b-code-button"
                :hidden="hiddenEditor"
                @click="toggleCodeEditor"
            />
            <bryntum-button
                ref="downloadButton"
                icon="b-icon-download"
                tooltip="Download this demo zip archive"
                cls="b-raised b-blue"
                :hidden="true"
                href="#"
            />
            <bryntum-fullscreen-button/>
        </div>
    </header>
</template>

<script>

import { AjaxHelper, CSSHelper, DemoCodeEditor } from '@bryntum/schedulerpro';
import BryntumButton from './BryntumButton.vue';
import BryntumFullscreenButton from './BryntumFullscreenButton.vue';

export default {

    name : 'BryntumDemoHeader',

    components : {
        BryntumFullscreenButton,
        BryntumButton
    },

    data() {
        return {
            refCodeButton : null
        };
    },

    computed : {
        link() {
            // Convert:
            // https://bryntum.com/products/schedulerpro/examples-scheduler/frameworks/vue-3/javascript/basic/build/
            // https://bryntum.com/products/schedulerpro/examples/frameworks/vue-3/javascript/basic/build/
            // To:
            // https://bryntum.com/products/schedulerpro/examples/#example-examples-scheduler-frameworks-vue-3-basic
            // https://bryntum.com/products/schedulerpro/examples/#example-frameworks-vue-3-basic

            const match = /(.*?\/)(examples.*?\/frameworks\/.*?)\/dist/.exec(document.location.href);
            return match ? `${match[1]}examples/#example-${match[2].replace(/\//gm, '-').replace('examples-frameworks', 'frameworks')}` : '#';
        },

        hiddenEditor() {
            return !Boolean(DemoCodeEditor.monacoCodePath);
        },

        isTest() {
            return document.location.search.includes('test');;
        }
    },

    props : {
        title     : { type : String, default : document.title.split(' - ')[1] || document.title },
        appFolder : { type : String, default : '../' }
    },

    async mounted() {
        if (!this.hiddenEditor) {
            CSSHelper.insertRule('body { flex-direction : row !important }');
            CSSHelper.insertRule('#container, #app { flex : 1 !important; overflow : hidden !important }');

            const appConfig = (await AjaxHelper.get(`${this.appFolder}app.config.json`, { parseJson : true })).parsedJson;
            if (appConfig.zip || this.isTest) {
                const downloadButton = this.$refs.downloadButton;
                downloadButton.hidden = false;
                downloadButton.href = `${this.appFolder}${appConfig.zip}`;
            }
        }
    },

    methods : {
        async toggleCodeEditor() {
            this.codeEditor = await DemoCodeEditor.toggleCodeEditor(
                this.codeEditor,
                this.$refs.codeButton,
                {
                    appFolder        : this.appFolder,
                    preferredSources : [
                        /App\.vue/,
                        /\w+Config\.[tj]s/
                    ]
                }
            );
        }

    }

};

</script>
